import { render, staticRenderFns } from "./CompetitorStatsDialogDisplay.vue?vue&type=template&id=b8b5b1b0"
import script from "./CompetitorStatsDialogDisplay.vue?vue&type=script&lang=js"
export * from "./CompetitorStatsDialogDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports